import * as React from 'react'
import PropTypes from 'prop-types'
import ParagraphSection from './ParagraphSection'
import YoutubeSection from './YoutubeSection'
import FormSection from './FormSection'

const Section = ({ section, className = '' }) => {
  const componentKey = section.strapi_component ? section.strapi_component : section.__component
  
  switch (componentKey) {
    case 'section.paragraph':
      return <ParagraphSection section={section} className={className} />

    case 'section.youtube-videos':
      return <YoutubeSection section={section} className={className} />

    case 'section.form':
      return <FormSection section={section} className={className} />

    default:
      return null
  }
}


Section.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    videos: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })),
    strapi_component: PropTypes.string,
    __component: PropTypes.string,
  })
}

Section.defaultProps = {
  section: {
    heading: '',
    content: '',
    strapi_component: '',
  }
}

export default Section